/**
 * @prop --popover-surface-width: Width of the popover surface. Defaults to `auto`
 * @prop --popover-body-background-color: Background color of popover body. Defaults to `--lime-elevated-surface-background-color`.
 * @prop --popover-border-radius: Border radius of popover. Defaults to `0.75rem`.
 * @prop --popover-z-index: z-index of the popover.
 * @prop --popover-box-shadow: Defines the shadow of the popover surface. Defaults to `--shadow-depth-16`.
 */

.trigger-anchor {
    display: inline-block;
    position: relative;
}
